import script from "./my-business.vue?vue&type=script&setup=true&lang=js"
export * from "./my-business.vue?vue&type=script&setup=true&lang=js"

import "./my-business.vue?vue&type=style&index=0&id=5ff8c764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff8c764"]])

export default __exports__